// css
import './assets/style/custom.scss'
import 'jssocials/dist/jssocials.css';
import 'jssocials/dist/jssocials-theme-flat.css';


// js
import './assets/js/vendors/jquery.cookiesdirective_es.js'
import './assets/js/vendors/owl-carousel/owl.carousel.js'
import './assets/js/custom'
import './assets/js/carousel'


// WEBPACK FOOTER //
// ./app.js